export default __webpack_public_path__ + "static/media/Image From ET__UI_2.69479bec.png";